import React from 'react'
import { Card, CardProps } from '@mui/material'

const MuiCard: React.FC<CardProps> = ({ ...props }: CardProps) => {
  return <Card square elevation={4} {...props} />
}

export default MuiCard
